
import React from 'react';
import { CommandInput } from '@/components/ui/command';
import { Button } from '@/components/ui/button';
import { Download } from 'lucide-react';

interface ContactsSearchHeaderProps {
  searchTerm: string;
  onSearchChange: (value: string) => void;
  onDownload: () => void;
}

const ContactsSearchHeader: React.FC<ContactsSearchHeaderProps> = ({
  searchTerm,
  onSearchChange,
  onDownload
}) => {
  return (
    <div className="flex items-center justify-between p-2 border-b">
      <CommandInput 
        placeholder="Search contacts..." 
        value={searchTerm}
        onValueChange={onSearchChange}
        className="border-none focus:ring-0"
      />
      <Button 
        variant="outline" 
        size="icon" 
        onClick={onDownload}
        title="Download contacts"
      >
        <Download className="h-4 w-4" />
      </Button>
    </div>
  );
};

export default ContactsSearchHeader;
